import { Button, Col, Input, Modal, Text, TextArea } from 'components';
import { Api, validateEmail } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

const SendUsAMessage = ({ visible, closeModal }) => {
  const [email, setEmail] = useState(''),
    [message, setMessage] = useState(''),
    { t } = useTranslation(),
    textAreaRef = useRef(null),
    isDisabled = !validateEmail(email) || message.length < 20,
    dispatch = useDispatch();

  useEffect(() => {
    setEmail('');
    setMessage('');
  }, [visible]);

  async function submit() {
    if (!validateEmail(email) || message.length < 20) return;

    const res = await Api.post('/website/sendAMessage', { email, message }, 'sendAMessage');
    if (!res) return;

    closeModal();

    dispatch({
      type: 'HANDLE_RES',
      payload: { res: t('website.messageSent') }
    });
  }

  return (
    <Modal visible={visible} closeModal={closeModal}>
      <Col start noFlex ht="550px" wid="100%" style={{ overflow: 'hidden' }}>
        <Col noFlex wid="100%" centerAll marg="24px" style={{ overflow: 'hidden' }}>
          <Col wid="calc(100% - 48px)">
            <Text h3 marg=" 0 10px">
              {t('website.sendUsAMessage')}
            </Text>

            <Input
              marg="30px 0 0"
              website
              title="Email"
              placeholder="Your email"
              value={email}
              onChange={({ target }) => setEmail(target.value)}
            />

            <Text b2 med marg="30px 0 4px 16px">
              {t('common.yourMessage')}
            </Text>

            <TextArea
              ht="200px"
              ref={textAreaRef}
              onChange={({ target }) => setMessage(target.value)}
              placeholder={t('common.typeYourMessage')}
            />

            <Button
              big
              text={t('common.submit')}
              marg="30px 0 0"
              disabled={isDisabled}
              onClick={submit}
              action="sendAMessage"
            />
          </Col>
        </Col>
      </Col>
    </Modal>
  );
};

export default SendUsAMessage;
